import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@app/shared/material/material.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-save-warning-dialog',
    templateUrl: './save-warning-dialog.component.html',
    styleUrl: './save-warning-dialog.component.scss',
    imports: [CommonModule, MaterialModule, TranslateModule],
})
export class SaveWarningDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<SaveWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    onBack(): void {
        this.dialogRef.close('back');
    }

    onCloseWithoutSaving(): void {
        this.dialogRef.close('closeWithoutSaving');
    }

    onSaveAndExit(): void {
        this.dialogRef.close('saveAndExit');
    }
}
